<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <h5 class="title dialog-title t-apply"></h5>

                    <div class="msg-view">
                        <div class="text">
                            <p><b>{{ player_data.nickName }}</b>邀请你进行绑定，</p>
                            <p>每人仅可接受一位好友的绑定，是否接受？</p>
                        </div>
                    </div>

                    <!-- <div class="warn">活动期间，只能接受一个邀请。</div> -->

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="apply"></div>                                                                 
                    </div>
                    
                </div>
            </div>            
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.apply-modal{
    width: 667px;
    height: 378px;
    background-image: url(~@/assets/images/modal/bg-modal_sm.png);
}

.t-apply{
    width: 429px;
    height: 64px;
    margin: 0 auto 30px;
    background-image: url(~@/assets/images/modal/title-invite_apply.png);      
}

.msg-view{
    text-align: center;
    margin: 0 auto 0;
    padding: 10px 20px;

    // border: 1px solid #f6d4c9;
    // border-radius: 50px;

    color: #cbbda5;
    line-height: 1.8;

    font-size: 20px;

    b{
        padding: 0 10px;
        color: #ecd1a4;
    }


}

.warn{
    margin-top: 20px;
    font-size: 20px;
    text-align: center;
    color: #ad9786;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
    padding: 0 40px;
}

.u-btn.ok{
    width: 230px;
    height: 76px;
    margin: 0 20px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 230px;
    height: 76px;
    margin: 0 20px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<script>
import { apiInviteApply , apiInviteInfo } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码
            message : {
                '1009' : '该玩家已与三位玩家绑定！',
                '1013' : '您已绑定该玩家，请勿重复绑定！',
                '1012' : '您已经绑定其他玩家！',
            },   
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.render();
    },
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        render() {
            var _this = this;
            apiInviteInfo({code : this.code}).then(
                res => {
                    this.player_data = res.data;
                },
                rej => {
                    this.error_text = rej.message || '请稍后再试';
                    this.$toast(rej.message);
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                      
                },
            );
        },        
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            apiInviteApply({ code : this.code }).then(
                res => {
                    this.destroyElement();
                    this.$msg_modal('绑定成功，快去参与活动吧！')
                    //this.$apply_success();
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                   
                },
                rej => {
                    this.destroyElement();
                    let error = rej.code == 404 ? '绑定已上限，助理失败！' : rej.message;
                    //this.$toast(error);
                    this.$msg_modal(this.message[rej.code] || rej.message);
                    
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                       
                },
            );
        },                
    },
}
</script>